import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function twoFieldsOrValidator(fg: FormGroup, conditionalField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const conditionalFieldControl = fg.get(conditionalField);
    if (conditionalFieldControl) {
      if (conditionalFieldControl.value == null || conditionalFieldControl.value === "") {
        if (control.value == null || control.value === '') {
          const controlName = Object.keys(fg.controls).find(key => fg.controls[key] === control) || 'Field';
          const errorKey = `${controlName}Required`;
          return { [errorKey]: true };
        }
      }
    }
    return null;
  }
}
